module.exports = __webpack_public_path__ + "static/media/blue-bell-icon.b879dbda.svg";